var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.627,
    height: 20.627,
    viewBox: "0 0 20.627 20.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(-684 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-circle",
    transform: "translate(684 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H20.627V20.627H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.595,0a8.595,8.595,0,1,0,8.595,8.595A8.6,8.6,0,0,0,8.595,0ZM5.715,10.975a.647.647,0,0,1-.6.421.517.517,0,0,1-.223-.043A3.152,3.152,0,0,1,3.24,9.927a3.417,3.417,0,0,1,1.177-4.5L6.429,4.177A3.1,3.1,0,0,1,10.8,5.311a3.417,3.417,0,0,1-1.177,4.5L9.4,9.978A.646.646,0,1,1,8.646,8.93l.266-.189a2.127,2.127,0,0,0,.765-2.8,1.841,1.841,0,0,0-1.134-.894,1.789,1.789,0,0,0-1.427.223L5.088,6.523a2.12,2.12,0,0,0-.731,2.785,1.864,1.864,0,0,0,.971.842A.644.644,0,0,1,5.715,10.975Zm7.108.756-2.011,1.246a3.1,3.1,0,0,1-4.366-1.143,3.417,3.417,0,0,1,1.177-4.5l.223-.163A.646.646,0,0,1,8.6,8.216l-.266.189a2.127,2.127,0,0,0-.765,2.8,1.841,1.841,0,0,0,1.134.894,1.789,1.789,0,0,0,1.427-.223l2.011-1.246a2.12,2.12,0,0,0,.731-2.785A1.864,1.864,0,0,0,11.9,7a.642.642,0,1,1,.447-1.2A3.152,3.152,0,0,1,14,7.228,3.425,3.425,0,0,1,12.823,11.732Z",
    transform: "translate(1.719 1.719)",
    fill: "#c2c2c2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8296c69d68a1bdcc20b909791c05fa41.svg";
export { ForwardRef as ReactComponent };